const pageNameKey = "otaBackupProcessInProgressModal";

export const otaBackupProcessInProgressModalEn = {
  [pageNameKey]: {
    title: "Create Backup",
    backupDetailsTemplate: "Operation ID {operationId}",
    waitingBulletPointSecureConnection:
      "Establishing a secure connection to the machine.",
    waitingBulletPointCreateBackup:
      "Creating a backup of the existing file structure in {targetPath}.",
    waitingBulletPointUploadBackup:
      "Uploading the backup to the cloud firmware storage.",
    targetPathFallback: "target path",
    pushInBackgroundButtonText: "Push to Background",
  },
};

export const otaBackupProcessInProgressModalPtBr = {
  [pageNameKey]: {
    title: "Criar backup",
    backupDetailsTemplate: "ID da operação {operationId}",
    waitingBulletPointSecureConnection:
      "Estabelecendo uma conexão segura com a máquina.",
    waitingBulletPointCreateBackup:
      "Criando um backup da estrutura de arquivos existente em {targetPath}.",
    waitingBulletPointUploadBackup:
      "Enviando o backup para o armazenamento de firmware na nuvem.",
    targetPathFallback: "caminho de destino",
    pushInBackgroundButtonText: "Executar em segundo plano",
  },
};

export const otaBackupProcessInProgressModalDe = {
  [pageNameKey]: {
    title: "Backup erstellen",
    backupDetailsTemplate: "Vorgangs-ID {operationId}",
    waitingBulletPointSecureConnection:
      "Es wird eine sichere Verbindung zur Maschine hergestellt.",
    waitingBulletPointCreateBackup:
      "Es wird eine Sicherung der bestehenden Dateistruktur in {targetPath} erstellt.",
    waitingBulletPointUploadBackup:
      "Die Sicherung wird in den Cloud-Firmware-Speicher hochgeladen.",
    targetPathFallback: "Zielpfad",
    pushInBackgroundButtonText: "Im Hintergrund ausführen",
  },
};

export const otaBackupProcessInProgressModalZhHans = {
  [pageNameKey]: {
    title: "创建备份",
    backupDetailsTemplate: "操作 ID {operationId}",
    waitingBulletPointSecureConnection: "正在与设备建立安全连接。",
    waitingBulletPointCreateBackup:
      "正在为 {targetPath} 中现有的文件结构创建备份。",
    waitingBulletPointUploadBackup: "正在将备份上传到云端固件存储。",
    targetPathFallback: "目标路径",
    pushInBackgroundButtonText: "后台运行",
  },
};

export const otaBackupProcessInProgressModalIt = {
  [pageNameKey]: {
    title: "Crea backup",
    backupDetailsTemplate: "ID operazione {operationId}",
    waitingBulletPointSecureConnection:
      "Connessione sicura alla macchina in corso.",
    waitingBulletPointCreateBackup:
      "Creazione di un backup della struttura file esistente in {targetPath}.",
    waitingBulletPointUploadBackup:
      "Caricamento del backup nello storage cloud del firmware.",
    targetPathFallback: "percorso di destinazione",
    pushInBackgroundButtonText: "Esegui in background",
  },
};

export const otaBackupProcessInProgressModalEs = {
  [pageNameKey]: {
    title: "Crear respaldo",
    backupDetailsTemplate: "ID de operación {operationId}",
    waitingBulletPointSecureConnection:
      "Estableciendo una conexión segura con la máquina.",
    waitingBulletPointCreateBackup:
      "Creando una copia de seguridad de la estructura de archivos existente en {targetPath}.",
    waitingBulletPointUploadBackup:
      "Subiendo la copia de seguridad al almacenamiento en la nube del firmware.",
    targetPathFallback: "ruta de destino",
    pushInBackgroundButtonText: "Ejecutar en segundo plano",
  },
};

export const otaBackupProcessInProgressModalNl = {
  [pageNameKey]: {
    title: "Back-up maken",
    backupDetailsTemplate: "Operatie-ID {operationId}",
    waitingBulletPointSecureConnection:
      "Er wordt een beveiligde verbinding met de machine opgezet.",
    waitingBulletPointCreateBackup:
      "Er wordt een back-up gemaakt van de bestaande bestandsstructuur in {targetPath}.",
    waitingBulletPointUploadBackup:
      "De back-up wordt geüpload naar de cloudopslag voor firmware.",
    targetPathFallback: "doelpad",
    pushInBackgroundButtonText: "Op de achtergrond uitvoeren",
  },
};

export const otaBackupProcessInProgressModalTr = {
  [pageNameKey]: {
    title: "Yedekleme Oluştur",
    backupDetailsTemplate: "Operasyon Kimliği {operationId}",
    waitingBulletPointSecureConnection: "Makineyle güvenli bir bağlantı kurma.",
    waitingBulletPointCreateBackup:
      "{targetPath}'de mevcut dosya yapısının yedeğini oluşturma.",
    waitingBulletPointUploadBackup:
      "Yedeği bulut ürün yazılımı deposuna yükleme.",
    targetPathFallback: "hedef yolu",
    pushInBackgroundButtonText: "Arka Plana Bas",
  },
};
